import { Flex, Tag } from '@chakra-ui/react';
import { TexasFormLabel } from '../form/TexasFormLabel';
import { useTranslation } from 'react-i18next';

export function TransportRequestsSummary({
  ticketNumbers,
  samplesCount,
}: {
  ticketNumbers?: number[];
  samplesCount: number | null;
}) {
  const { t } = useTranslation();
  return (
    <Flex direction="column">
      {ticketNumbers && ticketNumbers.length > 0 && (
        <>
          <TexasFormLabel mb={0}>
            {t('transportRequest.ticket', { count: ticketNumbers.length })}
          </TexasFormLabel>
          <Flex gap={1} flexWrap="wrap">
            {ticketNumbers.map((ticketNumber) => (
              <Tag key={ticketNumber} variant="colored" w="fit-content">
                #{ticketNumber}
              </Tag>
            ))}
          </Flex>
        </>
      )}
      {samplesCount && (
        <Tag w="fit-content" mt={2} variant="lighter">
          {t('shipment.samplesCount', {
            count: samplesCount,
          })}
        </Tag>
      )}
    </Flex>
  );
}
